import { useQuery } from '@tanstack/react-query'
import type { GalleryAllImages } from '../types'
import { fetchGalleryAllImages } from '../api/imageApi'

/**
 * Gallery images hook
 *
 * TODOs:
 * - [ ] Add `useUploadImage`, `useDeleteImage`, `useUpdateCaption`, `useReorderImages`
 * - [ ] Implement optimistic updates for reorder/caption
 * - [ ] Virtualized selectors should prefetch next chunk when scrolling
 */

interface UseGalleryImagesOptions {
  enabled?: boolean
}

export function useGalleryImages(galleryId?: number | null, options: UseGalleryImagesOptions = {}) {
  return useQuery<GalleryAllImages[]>({
    queryKey: ['gallery-images', galleryId],
    queryFn: () => fetchGalleryAllImages(galleryId as number),
    enabled: Boolean(galleryId) && options.enabled !== false,
    staleTime: 30_000,
    refetchOnWindowFocus: false
  })
}

// Mutations (upload/delete/caption) will live in a separate hook file to avoid pulling File type into many modules.
